import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AuthProvider, useAuth } from './ecollect/context/AuthContext';
import Layout from './ecollect/components/Layout';
import './App.css';

// Import pages
import PageHub from './ecollect/pages/PageHub';
import Login from './ecollect/pages/login';
import Dashboard from './ecollect/pages/Dashboard';
import AddCollection from './ecollect/pages/AddCollection';
import ViewHistory from './ecollect/pages/ViewHistory';
import CashBook from './ecollect/pages/CashBook';
import CashManagement from './ecollect/pages/CashManagement';
import StaffPerformance from './ecollect/pages/StaffPerformance';




// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Layout>{children}</Layout>;
};

// Public Route Component
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/hub" element={<PageHub />} />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-collection"
            element={
              <ProtectedRoute>
                <AddCollection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <ViewHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cashbook"
            element={
              <ProtectedRoute>
                <CashBook />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cash-management"
            element={
              <ProtectedRoute>
                <CashManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff-performance"
            element={
              <ProtectedRoute>
                <StaffPerformance />
              </ProtectedRoute>
            }
          />
          {/* Default Routes */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
